import React, { createContext, useContext, useState } from 'react';
import Loading from '../../Loading/Component/Loading';

// Create a Loading Context
const LoadingContext = createContext();

// Create a provider component
export const LoadingProvider = ({ children }) => {
  const [fullPageLoading, setFullPageLoading] = useState(false); // Set default loading state

  const setLoadingState = (state) => {
    console.log('setting loading state: ', state);
    setFullPageLoading(state);
  };

  return (
    <LoadingContext.Provider value={{ loading: fullPageLoading, setLoadingState }}>
      {/* {fullPageLoading && <Loading message="Fetching data, please wait..." />} */}
      {children}
    </LoadingContext.Provider>
  );
};

// Custom hook to use the Loading context
export const useLoading = () => {
  return useContext(LoadingContext);
};
